import { Component, OnInit } from '@angular/core';

// import { REPORTS } from '../models/reports';
import { PagerService } from '../services/pager.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-legacy-reports',
  templateUrl: './legacy-reports.component.html',
  styleUrls: ['./legacy-reports.component.css']
})
export class LegacyReportsComponent implements OnInit {
  private reports: any[];
  private error:string;

  private allItems: any[];
  private filteredReports: any[];
  pager: any = {};
  pagedItems: any[];

  //private legacyReportRoot: string = "http://r.oa.hvsfinancial.com.loc";
  private legacyReportRoot: string = "https://r.hvsfinancial.com";

  constructor(private pagerService: PagerService, private globalService: GlobalService, private snackBarService: SnackBarService, private loadingService: LoadingService) { 
    this.getReports();
  }

  ngOnInit() {
    // this.allItems = REPORTS;
    // this.filteredReports = REPORTS;
    // this.setPage(1);
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredReports.length, page);

    // get current page of items
    this.pagedItems = this.filteredReports.slice(this.pager.startIndex, this.pager.endIndex + 1);
    // console.log(this.pagedItems);
  }

  assignCopy(){
    this.filteredReports = Object.assign([], this.allItems);
  }

  // filterItem(value){
  //     if(!value) this.assignCopy();
  //     // console.log(this.allItems);
  //     this.filteredReports = Object.assign([], this.allItems).filter(
  //       report => ((report.c.FirstName + " " + report.c.LastName).toLowerCase().includes(value.toLowerCase()))
  //     )
  //     // console.log(this.filteredReports);
  //     this.setPage(1);
  // }

  filterItem(value){
    // console.log(value);
    //if(!value) this.assignCopy();
    this.filteredReports = Object.assign([], this.allItems).filter(
      report => ((report.title).toLowerCase().includes(value.toLowerCase()))
    );
    
    if (!this.filteredReports.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
}

  getReports() {
    this.loadingService.isLoading(true);
    this.globalService.getLegacyReportsData()
        .subscribe(
            reports => { 
              this.loadingService.isLoading(false);
              this.allItems = reports;
              this.filteredReports = this.allItems;
              this.filteredReports = this.allItems.sort(function(a, b) {
                return parseInt(b.reportID) - parseInt(a.reportID);
              });

              this.setPage(1);
              
              // console.log(reports);
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
            });
  }

  createDownloadLink(report) {
    var reportUrl = report.reportType == 2 ? this.legacyReportRoot + "/portal/GenSSReport.aspx?orgGUID=" + report.orgGUID + "&docId=" + report.reportID
    : report.reportType == 0 ? this.legacyReportRoot + "/portal/GenReport.aspx?reportId=0&orgGUID=" + report.orgGUID + "&docGUID=" + report.reportGUID
    : this.legacyReportRoot + "/portal/GenMTReport.aspx?orgGUID=" + report.orgGUID + "&docId=" + report.reportGUID + "&advisorGUID=" + report.advisorGUID + "&advisorId=" + report.advisorId;

    window.open(reportUrl);
    // console.log(reportUrl)
  }

  // downloadReport(e, report) {
  //   // console.log(report);
  //   this.loadingService.isLoading(true);
  //   this.snackBarService.add(`Downloading your ${this.formatReportTypeID(report.reportType)} report`, 0);

  //   //this.globalService.generateReport(ReportFields, report.c, report.r)
  //   this.globalService.generateLegacyReport(report)
  //     .subscribe(
  //     resp => {
  //       console.log('downloading report');
  //       this.loadingService.isLoading(false);
  //     },
  //     error => {
  //       this.error = <any>error;
  //       this.loadingService.isLoading(false);
  //     });
  // }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  formatReportTypeID(ReportTypeID: number) {
    return ReportTypeID == 2 ? 'Social Security' : ReportTypeID == 0 ? 'Healthcare' : 'Medicare Means Testing'
  }

  
}
